import { useMapStore } from '../stores/mapStore';
import { useAuthStore } from '../stores/authStore';

/** Recent searches are session-only and shown only to signed-in users. */
export function useVisibleRecentSearches() {
  const recentSearches = useMapStore((state) => state.recentSearches);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  return isAuthenticated ? recentSearches : [];
}
